/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'send': {
    width: 16,
    height: 16,
    viewBox: '0 0 100 100',
    data: '<path pid="0" d="M93.934 6.066a2.737 2.737 0 00-2.977-.586L6.941 40.558a2.723 2.723 0 00-1.675 2.528 2.718 2.718 0 001.703 2.508l33.789 13.645 13.645 33.785a2.723 2.723 0 002.523 1.703c1.106 0 2.086-.66 2.512-1.676L94.516 9.043c.43-1.027.199-2.192-.582-2.977zm-30.223 34.07c.512-.511.797-1.199.797-1.925 0-.73-.285-1.414-.797-1.926a2.725 2.725 0 00-3.852 0L42.195 53.949 15.152 43.027l71.785-29.973-29.973 71.785-10.922-27.043z"/>'
  }
})
